module.exports = __webpack_public_path__ + "1077fae4b504049604e6ab8e33eab4cb.pdf";